import { render } from "./aws-login.vue?vue&type=template&id=0362eec4&scoped=true"
import script from "./aws-login.vue?vue&type=script&lang=js"
export * from "./aws-login.vue?vue&type=script&lang=js"

import "./aws-login.vue?vue&type=style&index=0&id=0362eec4&scoped=true&lang=css"

import exportComponent from "/Users/qmaura/PANOPTIC/hkust-gz-vitals/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0362eec4"]])

export default __exports__